import { PenTool, ReceiptText, ListChecks, KeyRound, Unlock } from "lucide-react";
import { Reveal, SectionLabel } from "../components/Reveal";

const ITEMS = [
  {
    icon: PenTool,
    title: "Prima bozza gratuita",
    text: "Puoi vedere una prima proposta visiva del progetto prima di decidere se procedere.",
  },
  {
    icon: ReceiptText,
    title: "Costi chiari prima di iniziare",
    text: "Caratteristiche e costo del progetto vengono definiti prima della realizzazione completa.",
  },
  {
    icon: ListChecks,
    title: "Revisioni concordate",
    text: "Il progetto viene controllato insieme prima della pubblicazione.",
  },
  {
    icon: KeyRound,
    title: "Il sito rimane al cliente",
    text: "A progetto concluso ricevi gli accessi necessari alla gestione della tua infrastruttura.",
  },
  {
    icon: Unlock,
    title: "Nessun vincolo obbligatorio di gestione",
    text: "Puoi continuare con DS LAB STUDIO oppure gestire il sito autonomamente o affidarlo a un altro professionista.",
  },
];

export const Trust = () => (
  <section id="fiducia" aria-labelledby="fiducia-title" className="border-y border-white/10 bg-navy-dark text-white">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal className="max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-celeste">Trasparenza</p>
        <h2 id="fiducia-title" className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl">
          Un processo chiaro, fin dall'inizio.
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.08} className={i === 4 ? "sm:col-span-2 lg:col-span-1" : ""}>
            <article className="h-full rounded-xl border border-white/10 bg-white/[0.04] p-6 transition-colors duration-300 hover:border-celeste/50">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-celeste/15 text-celeste" aria-hidden="true">
                <item.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 font-display text-base font-semibold">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/65">{item.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
